import LoginForm from './LoginForm'
import { useSelector, useDispatch } from 'react-redux'
import { useEffect, useState  } from 'react'
import { getStrategies } from '../../redux/slices'
import { DefaultState } from '../../types'
import { LoadIndicator } from 'devextreme-react'
import Register from './Register'
import SSOItems from './SSOItems'
import { useLocation, useNavigate } from 'react-router-dom'
import ICSErrorCard from '../../components/ICSErrorCard/ICSErrorCard'
import AcceptableUsagePolicy from './AcceptableUsagePolicy'

const LoginPageBody = () => {
  const { loading, form, sso, allow_register_users, aupPolicy, error } =
    useSelector((state: DefaultState) => state.strategies)
  const session = useSelector((state: DefaultState) => state.session)
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const [aUP, setAUP] = useState<boolean>(false)

  useEffect(() => {
    dispatch(getStrategies())
  }, [])

  useEffect(() => {
    if (session.data.accessToken) {
      //todo this should be moved to a different place? does the nav auth module handle this
      if(location?.state?.from?.pathname) {
        navigate(
          location.state.from.pathname,
          { replace: true }
        )
      } else {
        window.location.replace('/ui/#!/')
      }
    }
  }, [session.data.accessToken])

  const toggleItem = () => {
    console.log(
      `User has accepted the Acceptable Usage Policy`
    )
    setAUP(!aUP)
  }

  useEffect(() => {
    if (aupPolicy.length > 0) {
      setAUP(true);
    }
  }, [aupPolicy]);

  if (error) {
    return (
      <ICSErrorCard
        code={error ? 'auth' : 'error'}
        message={error ? 'Authorization Error' : ''}
        fields={[]}
      />
    )
  } else if (loading || session.data.accessToken || session.loading) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <LoadIndicator />
      </div>
    )
  } else if (aUP) {
    return (
      <>
        <AcceptableUsagePolicy policy={aupPolicy} accept={toggleItem}/>
      </>
    )
  } else {
    return (
      <>
        {form && <LoginForm />}
        <SSOItems ssoItems={sso} />
        {/* {sso.length > 0 && <SSOItems ssoItems={sso} />} */}
        {allow_register_users && <Register />}
      </>
    )
  }
}

export default LoginPageBody